module.exports = __webpack_public_path__ + "static/media/mark-harrison.edcce31d.jpg";